module.exports = __webpack_public_path__ + "img/quote-down-square.09ddb8fa.svg";